import React from "react";

const RenewalReminders = ({ data }) => {
    const renewalData = [
        { hygiene: "Service due", current: data?.service_Current || 0, next: data?.service_Next || 0 },
        { hygiene: "AMC Renewal", current: data?.AMC_Current || 0, next: data?.AMC_Next || 0 },
        { hygiene: "Insurance Renewal", current: data?.insurance_Current || 0, next: data?.insurance_Next || 0 },
        { hygiene: "Retro Fitment", current: data?.Retro_fitment_Current || 0, next: data?.Retro_fitment_Next || 0 },
    ];

    return (
        <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-bold text-gray-800 mb-4">Renewal Reminders</h2>

            <div className="overflow-x-auto">
                <table className="w-full border border-gray-200 rounded-t-md rounded-lg">
                    <thead className="rounded-t-md">
                        <tr className="bg-[#1467B3] rounded-t-md text-white">
                            <th className="px-4 py-3 text-left font-semibold">Hygiene Reminder</th>
                            <th className="px-4 py-3 text-left font-semibold">Current Month</th>
                            <th className="px-4 py-3 text-left font-semibold">Next Month</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renewalData.map((row, index) => (
                            <tr
                                key={index}
                                className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
                            >
                                <td className="px-4 py-3 text-gray-700">{row.hygiene}</td>
                                <td className="px-4 py-3 text-gray-900 font-semibold">{row.current}</td>
                                <td className="px-4 py-3 text-gray-900 font-semibold">{row.next}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default RenewalReminders;
